export enum InputModeEnum {
    // none = 0,
    text = 0,
    numeric,
    decimal,
    email,
    tel,
    url
    // search
}